import isEqual from 'deep-equal';
import type { NextRouter } from 'next/router';
import { useEffect, useRef } from 'react';
import type { Filters, ResultData } from '@/domain';
import { trackResultPage } from '@/lib/tracking/tracking';

const shallowEqual = (a: Record<string, unknown>, b: Record<string, unknown>): boolean => {
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    return keysA.every((key) => a[key] === b[key]);
};

export const useResultPageTracking = (filters: Filters, data: ResultData | undefined, router: NextRouter) => {
    const prevFilters = useRef<Filters>(filters);
    const prevNumResults = useRef<number | undefined>();

    useEffect(() => {
        const filtersChanged = !shallowEqual(filters, prevFilters.current) && !isEqual(filters, prevFilters.current);
        const numResults = data?.stats?.numResults;
        const numResultsChanged = numResults !== prevNumResults.current;

        if (!filtersChanged && !numResultsChanged) {
            return;
        }

        prevFilters.current = filters;
        prevNumResults.current = numResults;

        if (numResultsChanged && data && numResults !== undefined) {
            trackResultPage('Grid', { data, filters });
        }

        if (filtersChanged) {
            router.replace({ pathname: router.pathname, query: filters }, undefined, { shallow: true });
        }
    }, [filters, data, router]);
};
